import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga";

const usePageView = () => {
  const location = useLocation();

  useEffect(() => {
    if (process.env.REACT_APP_ENV === "production") {
      ReactGA.pageview(location.pathname);
    }
  }, [location]);
};

export default usePageView;
